import React, { useState, useEffect, useCallback } from "react";
import styles from "./FormModal.module.css";
import Button from "./Button";
import IconButton from "./IconButton";
import { ICON_PATHS } from "../../constants/iconPaths";

function Modal({ isOpen, onClose, onSubmit, children }) {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300);
  }, [onClose]);

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, handleClose]);

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  // 모달 컨테이너 클릭 시 닫기 (사이드바 클릭은 제외)
  const handleContainerClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className={styles.modalContainer} 
      onClick={handleContainerClick}
    >
      <div
        className={`${styles.modalSidebar} ${isClosing ? styles.slideOut : ''}`}
      >
        <div className={styles.modalHeader}>
          <IconButton icon={ICON_PATHS.close} onClick={handleClose} />
          <Button styleType="Primary" size="Medium" state="Enabled" onClick={onSubmit}>저장</Button>
        </div>
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>
  );
}

export default Modal;